module.exports = __webpack_public_path__ + "img/DG.da2dbba4.svg";